var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.916 25.895c0 6.554-5.313 11.866-11.867 11.866-6.553 0-11.865-5.313-11.865-11.866s5.312-11.866 11.865-11.866c6.554 0 11.867 5.313 11.867 11.866",
    fill: "#21EA9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M50.05 52.096c21.37 0 39.73-10.332 47.763-25.112C89.78 12.204 71.419 1.873 50.05 1.873S10.32 12.205 2.287 26.984c8.033 14.78 26.394 25.112 47.763 25.112z",
    stroke: "#21EA9F",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M72.022 26.316c0 12.135-9.837 21.971-21.972 21.971-12.133 0-21.97-9.836-21.97-21.97 0-12.135 9.837-21.971 21.97-21.971 12.135 0 21.972 9.836 21.972 21.97z",
    stroke: "#21EA9F",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEye);
export default __webpack_public_path__ + "static/media/smallEye.786e7b5b12b79cd1ba754963753d7683.svg";
export { ForwardRef as ReactComponent };